import { createSlice } from '@reduxjs/toolkit';
import { setAutoFreeze } from 'immer';
setAutoFreeze(false); // 禁止凍結

const initialState = {
  teachStep: localStorage.getItem('isReadTeach') ? -1 : 0,
  viewTour_0: null,
  viewTour_1: null,
  viewDay_0: null,
  viewDay_1: null,
  viewDayBox_0: null,
  viewDayBox_1: null,
  viewAddTour: null,
  viewAddDay: null,
  phoneViewTour_0: null,
  phoneViewTour_1: null,
  phoneViewDay_0: null,
  phoneViewDay_1: null,
  phoneViewAddTour: null,
  phoneViewAddDay: null,
};

export const teachSlice = createSlice({
  name: 'teach',
  initialState,
  reducers: {
    teachUpdate: (state, action) => {
      return action.payload;
    },
  },
});

/** 行程調整 */
export const teachSelect = (state) => state.teach;
export const { teachUpdate, teachReset } = teachSlice.actions;
export default teachSlice.reducer;
